module.exports = __webpack_public_path__ + "img/geofisica_16-9_640.af0eb761.webp";